///<reference path="processResource.ts"/>
///<reference path="process.ts"/>

module ProcessEditor {
    'use strict';

    export class ProcessService {
        public currentProcess: Process;
        static $inject = ["ProcessDataResource", "$q", "$http", "notifications", "getUsedTagsUrl"];
        public constructor(private ProcessData: IProcessDataResource, private $q: ng.IQService, private $http: ng.IHttpService, private notifications: INotifications, private getUsedTagsUrl: string) {
        }

        public getData(id: string|number, version: number = null): ng.IPromise<Process> {
            var deferred = this.$q.defer<Process>();

            if (id === null) {
                this.currentProcess = new Process();
                deferred.resolve(this.currentProcess);
                return deferred.promise;
            }

            var queryParams = this.getQueryParams(id, version);

            this.ProcessData.get(queryParams, (result: Frends.IJsonResponse) => {
                if (result.success) {
                    try {
                        this.currentProcess = new Process(<IProcessData>result.data);
                        deferred.resolve(this.currentProcess);
                    } catch (error) {
                        this.notifications.error("Error when reading Process: " + error);
                        deferred.reject(error);
                    }
                } else {
                    deferred.reject(result.errorMessage);
                }
            }, (error) => {
                deferred.reject(error);
            });

            return deferred.promise;
        }

        public save(process: Process): ng.IPromise<Frends.IJsonResponse> {
            var deferred = this.$q.defer<Frends.IJsonResponse>();
            this.ProcessData.save(process.getProcessData(), (response: Frends.IJsonResponse) => {
                deferred.resolve(response);
            });

            return deferred.promise;
        }

        public getUsedTags() {
            return this.$http.get(this.getUsedTagsUrl);
        }

        private getQueryParams(id, version): IProcessQueryParams {
            if (_.isNumber(id)) {
                return { id: id };
            }
            if (_.isString(id)) {
                var guidRegexp = /^[A-F0-9]{8}(?:-[A-F0-9]{4}){3}-[A-F0-9]{12}$/gi;
                if (id.match(guidRegexp)) {
                    if (version) {
                        return { guid: id, version: version }
                    }
                    return { guid: id };
                }

                // check if the id parameter is a number, just passed in as string
                var idNumber = parseInt(id);
                if (!isNaN(idNumber)) {
                    return { id: idNumber };
                } else {
                    // ok, just assume string
                    return { name: id }
                }
            }
            throw "Unknown id " + id;
        }
    }

    app.service("ProcessService", ProcessService);

    interface IProcessQueryParams {
        id?: number;
        name?: string;
        guid?: string;
        version?: string;
    }
}

module Frends {
    export interface IJsonResponse {
        success: boolean;
        data: any;
        errorMessage: string;
    }
}